export default "__VITE_ASSET__BD5ibW1o__"